// Dynamic translation loader
// Loads translations from per-language JSON files

import svTranslations from './sv.json';
import enTranslations from './en.json';
import plTranslations from './pl.json';
import esTranslations from './es.json';
import arTranslations from './ar.json';
import frTranslations from './fr.json';

export const translations = {
  sv: svTranslations,
  en: enTranslations,
  pl: plTranslations,
  es: esTranslations,
  ar: arTranslations,
  fr: frTranslations,
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.sv?.[key] || key;
};

export const getSupportedLanguages = () => Object.keys(translations);

export default translations;
